import * as React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { JobTypesLocationView } from './JobTypesLocationView';
import { JobTypesView } from './JobTypesView/JobTypesView';

export const JobTypeSwitch: React.FC<RouteComponentProps<{ id?: string }>> = ({
  match: { url, path },
}) => (
  <React.Fragment>
    <BreadcrumbsItem to={url}>Job Types</BreadcrumbsItem>

    <Switch>
      <Route exact path={path}>
        <JobTypesView />
      </Route>

      <Route path={`${path}/:id([0-9]+)/locations`}>
        <JobTypesLocationView />
      </Route>

      <Route>
        <Redirect to={path} />
      </Route>
    </Switch>
  </React.Fragment>
);
